import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'src/components/ui/GlobalComponents/PageHeader/PageHeader';
import Financial from './Financial/Financial';
import IranianBanner from './IranianBanner/IranianBanner';
import styles from './Membership.module.scss';
import Plans from './Plans/Plans';
import { Reasons } from './Reasons/Reasons';

export const Membership = () => {
    const { t } = useTranslation();
    const [country, setCountry] = useState<string>('GB');
    return (
        <div className={styles.membership}>
            <PageHeader title={t('12 Reasons to Join')} />
            <IranianBanner country={country} />
            <Reasons />
            <Plans country={country} setCountry={setCountry} />
            <Financial />
        </div>
    );
};
